const Screens = {
    // =========================================================================
    // Auth
    // =========================================================================
    AUTH: "/auth",
    LOGIN: "/auth/login",
    LOGIN_REDIRECT: "/auth/callback",

    NOT_FOUND: "/404",
    RESET_PASSWORD: "/resetPassAuth",
    SECOND_LOGIN: "/auth/second_login",
    FORGOT_PASSWORD: "/auth/forgot-password",

    // =========================================================================
    // Main
    // =========================================================================
    /** / */
    HOME: "/",
    PROFILE: "/profile",
    DASHBOARD: "/dashboard",

    ORGANIZATION_LIST: "/organization/list",
    ORGANIZATION_CREATE: "/organization/create",
    ORGANIZATION_DETAIL: "/organization/detail",

    DEPARTMENT_LIST: "/department/list",
    DEPARTMENT_CREATE: "/department/create",
    DEPARTMENT_DETAIL: "/department/detail",

    USER_LIST: "/user/list",
    USER_CREATE: "/user/create",
    USER_DETAIL: "/user/detail",

    PUSH_NOTIFICATION: "/push-notification",

    REPORT: "/reports",
    SYNTHETIC: "/synthetic",
    STATISTIC: "/statistics",
    MONITORING: "/monitorings",
    ASSIGNMENT: "/report-assignment",
    REPORT_INCIDENT: "/report-incident",
    REPORT_ANALYSIS: "/report-analysis",

    SETTING: "/setting",
    PROJECT: "/project",
    PROJECT_MEMBER: "/project-member",
    PROJECT_MEMBER_CREATE: "/project-member/create",
    PROJECT_ORGANIZATION: "/project/project-organization",

};

export default Screens;
